jQuery(document).ready(function() {
    jQuery(".blog_filter a").on("click", function() {
        jQuery(".tagged").removeClass("active");
        jQuery(this).parent().addClass("active");
    }).filter(function() {
        return window.location.href.indexOf(jQuery(this).attr('href').trim()) > -1;
    }).click();
    var url = window.location.href;
    var arr = url.split('tagged/')[1];
    if (url.indexOf('tagged/') > -1) {
        jQuery("#contribution_status_id option[data-tag='" + arr + "']").attr("selected", "selected");
    }
    jQuery('.ooo-instagram').parents('.section').addClass('instagram-feed');
    if (window.location.href.indexOf('/collections/all') > -1) {
        window.location.href = '/collections/shop';
    }
    jQuery('.footer-block__details-content li a').click(function() {
        jQuery(this).addClass('list-menu__item--active');
        jQuery('.footer-block__details-content li a.list-menu__item--active').removeClass('list-menu__item--active');
    });
   
});

//vimeo video
jQuery(document).on('click', '.deferred-media__poster-button_watch', function() {
    jQuery(this).parents('.video-section').find('.title-wrapper').fadeOut();
    jQuery(this).fadeOut();
    jQuery('.video-section.video_unmute').removeClass('video_unmute')
    jQuery(this).parents('.video-section').addClass('video_unmute');
       var video = document.getElementById('embedded_video');
       //Create a new Vimeo.Player object
       var player = new Vimeo.Player(video);
      //When the player is ready, set the volume to 0
       player.ready().then(function() {
          player.setVolume(1);
      });
});

// STICKY BAR 
jQuery(window).scroll(function() {
    var productForm = jQuery('.product-page [data-ele="product-add-to-cart"]');
    if (typeof productForm != 'undefined' && productForm.length) {
        var top_height = productForm.offset().top;
        if (jQuery(window).scrollTop() >= top_height) {
            jQuery('body').addClass('add-to-cart-sticky');
        } else {
            jQuery('body').removeClass('add-to-cart-sticky');
        }
    }
});
//lazyloading
document.addEventListener("DOMContentLoaded", function() {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

});
if (window.location.href.indexOf("careers") > -1) {
document.querySelector('.empty_state').innerHTML = "We are always looking for new talent so please reach out to hello@brooklyndelhi.com with your resume and a short note about why you'd like to work with Brooklyn Delhi."
jQuery('.shophire_page').parent().addClass('careers_bg');
}